import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssignContactsV2Component } from './assign-contacts-v2.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: AssignContactsV2Component, data: { title: 'Assign Contacts' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AssignContactsV2RoutingModule { }
